import gsap from 'gsap';
import { ScrollSmoother } from 'gsap/ScrollSmoother';

gsap.registerPlugin(ScrollSmoother);

/** Instantly reset scroll position — use after route changes instead of smooth scrolling. */
export function resetPageScrollPosition(): void {
  const smoother = ScrollSmoother.get();
  if (smoother) {
    smoother.scrollTo(0, false);
    smoother.kill();
  }

  window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;

  const smoothWrapper = document.getElementById('smooth-wrapper');
  if (smoothWrapper) {
    smoothWrapper.scrollTop = 0;
  }

  const smoothContent = document.getElementById('smooth-content');
  if (smoothContent) {
    gsap.set(smoothContent, { clearProps: 'transform' });
  }
}
